<div class="multiselect-wrapper relative" [class]="styleClass" [class.multiselect-wrapper--open]="isOpen">
  <div
    #triggerElement
    class="multiselect-trigger w-full min-w-[200px] border rounded-lg bg-white cursor-pointer transition-all duration-200"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    (mousedown)="onTriggerMousedownHandler()"
    (click)="toggleDropdown(); $event.stopPropagation()"
  >
    <div class="flex items-center justify-between p-2 min-w-0">
      <div class="multiselect-chip-area flex-1 flex items-center gap-2 min-h-[24px] min-w-0 overflow-hidden relative">
        <span
          *ngIf="selectedItems.length === 0"
          class="text-gray-500 text-sm"
        >
          {{ placeholder }}
        </span>

        <div
          #chipsMeasure
          *ngIf="selectedItems.length > 0 && selectedItems.length <= 2 && display === 'chip'"
          class="multiselect-chip-measure absolute left-0 right-0 top-0 flex items-center gap-2 flex-nowrap overflow-hidden opacity-0 pointer-events-none"
          aria-hidden="true"
        >
          <span
            *ngFor="let item of selectedItems"
            class="inline-flex flex-shrink-0 items-center gap-1.5 px-2.5 py-1.5 bg-[#00d084] text-white text-xs font-medium rounded-md"
          >
            {{ getOptionLabel(item) }}
          </span>
        </div>

        <ng-container *ngIf="showIndividualChips">
          <span
            *ngFor="let item of selectedItems"
            class="inline-flex min-w-0 max-w-full items-center gap-1.5 px-2.5 py-1.5 bg-[#00d084] text-white text-xs font-medium rounded-md shadow-sm hover:bg-[#00b875] transition-colors overflow-hidden"
          >
            <span class="min-w-0 truncate text-left" [title]="getOptionLabel(item)">{{ getOptionLabel(item) }}</span>
          </span>
        </ng-container>

        <span
          *ngIf="showChipSummary"
          class="inline-flex items-center gap-1.5 px-2.5 py-1.5 bg-[#00d084] text-white text-xs font-medium rounded-md shadow-sm"
        >
          {{ selectedItems.length }} selected
        </span>

        <span
          *ngIf="selectedItems.length > 0 && display === 'comma'"
          class="min-w-0 max-w-full text-gray-700 text-sm break-words"
        >
          {{ getDisplayValue() }}
        </span>
      </div>

      <div class="flex items-center gap-2 flex-shrink-0 ml-2">
        <svg
          *ngIf="selectedItems.length > 0 && showClear && !disabled"
          class="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          (click)="clearSelection(); $event.stopPropagation()"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>

        <svg
          class="w-5 h-5 text-gray-500 transition-transform duration-200"
          [class.rotate-180]="isOpen"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>
    </div>
  </div>

  <div
    #panelDropdown
    *ngIf="isOpen"
    class="multiselect-panel bg-white border border-gray-200 rounded-lg shadow-xl max-h-60 overflow-auto"
    [class.multiselect-panel--inline]="!shouldAppendToBody"
    (click)="$event.stopPropagation()"
  >
    <ng-container *ngIf="options && options.length > 0; else noOptions">
      <div *ngIf="filter" class="p-2 border-b border-gray-200">
        <input
          type="text"
          [(ngModel)]="searchTerm"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#00d084] focus:border-[#00d084]"
          placeholder="Search..."
          (click)="$event.stopPropagation()"
        />
      </div>

      <div class="py-1">
        <div
          *ngFor="let option of filteredOptions; trackBy: trackByOption"
          [class]="getOptionClasses(option)"
          (click)="toggleSelection(option)"
        >
          <div class="flex items-center mr-3 flex-shrink-0">
            <input
              type="checkbox"
              [checked]="isSelected(option)"
              class="checkbox-custom"
              (click)="$event.stopPropagation(); toggleSelection(option)"
              readonly
            />
          </div>

          <span
            class="text-sm text-gray-700 flex-1"
            [class.text-[#00d084]]="isSelected(option)"
            [class.font-medium]="isSelected(option)"
          >
            {{ getOptionLabel(option) }}
          </span>
        </div>

        <div *ngIf="filteredOptions.length === 0" class="px-3 py-2 text-sm text-gray-500 text-center">
          No options found
        </div>
      </div>
    </ng-container>

    <ng-template #noOptions>
      <div class="p-3 text-sm text-gray-500">No options available</div>
    </ng-template>
  </div>
</div>
